"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("preact/jsx-runtime");
var preact_1 = require("preact");
var TripSelect_1 = require("./components/TripSelect");
var i18n_1 = require("@wordpress/i18n");
var CartProvider_1 = require("./components/CartProvider");
(0, i18n_1.setLocaleData)(window.appformStrings, 'projects-abroad');
function reverseDateFormat(inputDate) {
    var parts = inputDate.split('-');
    if (parts.length !== 3 && parts[2].length !== 4) {
        return '';
    }
    return "".concat(parts[2], "-").concat(parts[1], "-").concat(parts[0]);
}
document.addEventListener("DOMContentLoaded", function () {
    var element = document.querySelector("#appform-react-root");
    var studyAbroadTripTypeId = element.getAttribute("data-study-abroad-trip-type-id");
    var productLineElements = document.getElementsByClassName("trip-selector__trip");
    var productLineData = Array.from(productLineElements).map(function (element) {
        var _a, _b;
        var id = element.getAttribute("data-product-line-id");
        var isGlobalGap = element.getAttribute("data-is-global-gap") === 'true' ? true : false;
        var tripTypeIds = (_b = (_a = element.getAttribute("data-trip-type-ids")) === null || _a === void 0 ? void 0 : _a.split(',')) !== null && _b !== void 0 ? _b : [];
        var name = element.querySelector(".trip-selector__button-title").textContent;
        var description = element.querySelector(".trip-selector__button-description").textContent;
        var logoElement = element.querySelector(".trip-selector__button img");
        var logo = logoElement ? logoElement.getAttribute("src") : null;
        return { id: id, name: name, description: description, logo: logo, isGlobalGap: isGlobalGap, tripTypeIds: tripTypeIds };
    });
    var hiddenCartElements = document.getElementsByClassName("hidden-cart-item");
    var cartData = Array.from(hiddenCartElements).map(function (element) {
        var cartId = element.getAttribute("data-cart-id");
        var startDate = reverseDateFormat(element.getAttribute("data-start-date"));
        var endDate = reverseDateFormat(element.getAttribute("data-end-date"));
        return { cartId: cartId, startDate: startDate, endDate: endDate };
    });
    if (element) {
        (0, preact_1.render)((0, jsx_runtime_1.jsx)(CartProvider_1.CartProvider, __assign({ initialValue: cartData }, { children: (0, jsx_runtime_1.jsx)(TripSelect_1.default, { productLines: productLineData, studyAbroadTripTypeId: studyAbroadTripTypeId }) })), element);
    }
});
